import cx from 'classnames';
import React from 'react';

type SkipLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

const SkipLink: React.FC<SkipLinkProps> = ({
  className,
  href = '#content',
  ...props
}) => {
  return (
    <a
      href={href}
      className={cx(
        'yst-outline-none yst-absolute yst--top-[1000em] yst-left-[10px] yst-z-[100000] yst-block yst-h-12 yst-min-w-[150px] yst-rounded yst-bg-[var(--bg-color-white)] yst-px-[15px] yst-text-center yst-text-[14px] yst-leading-[48px] yst-underline yst-shadow-md focus:yst-top-[10px] focus:yst-text-[var(--text-color-blue)]',
        className,
      )}
      {...props}
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
